export default "__VITE_ASSET__DSwkCTOv__"